import FolderService from 'src/services/folderServices';

const state = {
  folders: undefined
};

const getters = {
  getFolders: (state) => state.folders,
};
const actions = {
  async fetchFolders({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.folders == undefined) {
      return FolderService.fetchFolders()
      .then(r => {
        commit('setFolders', r.data);
      });
    }
  },
  unloadFolders({ commit }) {
    commit('setFolders', undefined);
  },
  addFolder({commit}, newFolder) {
    commit('addFolder', newFolder);
  },
  removeFolder({commit}, removeFolder) {
    commit('removeFolder', removeFolder);
  },
  renameFolder({ commit }, renamedFolder) {
    commit('renameFolder', renamedFolder)
  },
};
const mutations = {
  setFolders(state, folders) {
    // We can break these out by type if we care
    // but there are so few its less explicit this way for now.
    state.folders = folders;
  },
  addFolder(state, newFolder) {
    // We can break these out by type if we care
    // but there are so few its less explicit this way for now.
    state.folders.push(newFolder);
  },
  renameFolder(state, renamedFolder) {
    const folder = state.folders.find(f => f.id == renamedFolder.id);
    if (folder) {
      folder.folder_name = renamedFolder.folder_name;
    }
  },
  removeFolder(state, removeFolder) {
    state.folders = state.folders.filter(f => f.id != removedFolder.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
